import { render, staticRenderFns } from "./save-confirm.vue?vue&type=template&id=3433b55c&"
import script from "./save-confirm.vue?vue&type=script&lang=js&"
export * from "./save-confirm.vue?vue&type=script&lang=js&"
import style0 from "./save-confirm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports